import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import "./ErrorScreen.css";
import { useNavigate } from "react-router-dom";
import errorIcon404 from "../../assets/404.svg";
import errorIcon500 from "../../assets/500.svg";
import errorIcon403 from "../../assets/403.svg";
import { useTranslation } from "react-i18next";
import Avatar from "../../components/Avatar/Avatar";
import AppLogo from "../../assets/AppLogoBlue.svg";
import { useAuth } from "../../context/AuthContext";
import bellIcon from "../../assets/bell.svg";
import { userSelector, appSelector } from "../../store/selectors";
import ProfilePopup from "../../components/ProfilePopup/ProfilePopup";
import NotificationsPopup from "../../components/NotificationsPopup/NotificationsPopup";

function ErrorScreen() {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const user = useSelector(userSelector);
  const { logout } = useAuth();
  const [showUserMenu, setShowUserMenu] = useState(false);
  const userName = user.email;
  const is404 =
    window.location.href.includes(404) ||
    window.location.href.includes("access");

  let errorIcon = errorIcon404;

  if (window.location.href.includes(500)) {
    errorIcon = errorIcon500;
  } else if (window.location.href.includes(403)) {
    errorIcon = errorIcon403;
  }

  let errorText =
    "Что-то пошло не так.\nПомогите сделать Таймлайнер лучше, напишите нам об ошибке и мы ее исправим.";

  if (window.location.href.includes(500)) {
    errorText = "Срочная эвакуация! В Таймлайнере чрезвычайная ситуация";
  } else if (window.location.href.includes(403)) {
    errorText = "У вас нет билета в этот раздел Таймлайнера";
  } else if (window.location.href.includes("access")) {
    errorText =
      "Скорее всего, у вас нет доступа к этому проекту. Попросите того, кто отправил вам ссылку добавить вас в проект";
  }

  const showTeamPopup = () => {
    setShowOrganizationPopup(true);
    setShowUserMenu(false);
  };

  return (
    <div className="App">
      <div className={"mainScreenHeader"}>
        <div className="header-left">
          <div
            onClick={() => navigate("/home")}
            className={"mainScreen-logoBlock"}
          >
            <img src={AppLogo} style={{ height: "80%" }} />
          </div>
          <div className="projects-filter"></div>
        </div>
        <div className="header-actions">
          <NotificationsPopup />
          <ProfilePopup />
        </div>
      </div>
      <div className="error-container-content">
        <img src={errorIcon} style={{ height: "60%" }} />
        {is404 && (
          <>
            {window.location.href.includes("access") ? (
              <div className="error-screen-main-text">
                Скорее всего, у вас нет доступа к этому проекту.{"\n"}
                Попросите того, кто отправил вам ссылку, добавить вас в проект
              </div>
            ) : (
              <div className="error-screen-main-text">
                Что-то пошло не так{"\n"}Помогите сделать Таймлайнер лучше,{" "}
                <a
                  style={{ fontSize: 16, fontWeight: 500, color: "white" }}
                  href="mailto:info@7cut.video"
                >
                  напишите нам
                </a>{" "}
                об ошибке, и мы ее исправим.
              </div>
            )}
          </>
        )}
        {!is404 && <span className="error-screen-main-text">{errorText}</span>}

        <button
          className="error-screen-button"
          onClick={() => navigate("/home")}
        >
          {t("common.goToMain")}
        </button>
      </div>
    </div>
  );
}

export default ErrorScreen;
